import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 3000 },
    id: String,
  }

  connect() {
    // Auto-dismiss after timeout (unless timeout is 0)
    if (this.timeoutValue > 0) {
      this.timeoutId = setTimeout(() => {
        this.close()
      }, this.timeoutValue)
    }
  }

  disconnect() {
    // Clear timeout if component is removed
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  close() {
    // Clear timeout if closing manually
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }

    // Add fade-out animation
    this.element.style.transition = 'opacity 200ms ease-out'
    this.element.style.opacity = '0'

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
